import React, { useState } from "react";
import SlotsContainer from "../Slots";
import DateSelector from "./DateSelector.component";
import "./slot.scss";

const BookSchedule = ({
  doctorId,
  onDateSelect,
  onSlotSelect,
  setStartTime,
  className,
  slotsClass,
  hideAnnotation,
  consultType,
  followUpEndDate,
  setConsultData,
  followUpInfo,
  bookFollowUp,
  fromCalender,
  calenderDate,
  track,
  selectedProcedure,
  procedureDetails,
  alternateNumber,
  doctor,
  apiConsultationType, //new add
  getSlotTime,
  handleSlotToEMpty,
  slugUrl,
  reschedule,
  handleInstruction,
  doctorSlug, //pasing doctor slug
  procedure_id, //passing procedure id for rescheduling
  type,
  selectedDateMeta,
  selectedClinic,
  clinicId, // passing for patient side rescheduling
  handleDate,
  selectedResourceProcedure,
  handleSelectResourceSlot,
  hasResourceAccess,
  addBooking,
  procedures,
  booking_type,
  isReschedule,
  isConsultant,
  isSchedule,
}) => {
  const [selectedDate, setSelectedDate] = useState({});
  const [dateSelectEnable, setDateSelectEnable] = useState(true);

  const selectDateHandler = (date) => {
    if (dateSelectEnable) {
      setSelectedDate(date);
      onDateSelect(date);
    }
  };

  return (
    <div className={"booking-calender-wrapper "}>
      {hideAnnotation ? "" : <h2>BOOK APPOINTMENT</h2>}
      <div className={addBooking ? "date-selector-disable" : ""}>
        <DateSelector
          consultType={consultType}
          followUpEndDate={followUpEndDate}
          onSelect={selectDateHandler}
          selectedDate={selectedDate}
          fromCalender={fromCalender}
          calenderDate={calenderDate}
          track={track}
          selectedDateMeta={selectedDateMeta}
        />
      </div>
      <SlotsContainer
        alternateNumber={alternateNumber}
        followUpInfo={followUpInfo}
        setConsultData={setConsultData}
        consultType={consultType}
        selectedDate={selectedDate.meta}
        doctorId={doctorId}
        onSelect={onSlotSelect}
        setStartTime={setStartTime}
        className={slotsClass}
        bookFollowUp={bookFollowUp}
        selectedProcedure={selectedProcedure}
        procedureDetails={procedureDetails}
        doctor={doctor}
        slugUrl={slugUrl}
        reschedule={reschedule}
        apiConsultationType={apiConsultationType}
        getSlotTime={getSlotTime}
        handleSlotToEMpty={handleSlotToEMpty}
        handleInstruction={handleInstruction}
        doctorSlug={doctorSlug} //passing doctor slug for patient/doctor reschedule
        procedure_id={procedure_id} //passing procedure id for patient/doctor reschedule
        type={type}
        selectedClinic={selectedClinic}
        clinicID={clinicId} // passing for patient side rescheduling
        setDateSelectEnable={setDateSelectEnable}
        handleDate={handleDate}
        selectedResourceProcedure={selectedResourceProcedure}
        handleSelectResourceSlot={handleSelectResourceSlot}
        hasResourceAccess={hasResourceAccess}
        addBooking={addBooking}
        procedures={procedures}
        booking_type={booking_type}
        isReschedule={isReschedule}
        isConsultant={isConsultant}
        isSchedule={isSchedule}
      />
    </div>
  );
};

export default BookSchedule;
